import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrlApi } from "../../proxy";
export const getKeys = async () => {
  try {
    const response = await axios.get(`${baseUrlApi}moyasar/keys`);
    return response?.data;
  } catch (error) {
    throw error;
  }
};

export const getAllKorba = createAsyncThunk("korba/get-korba", async () => {
  try {
    const response = await axios.get(`${baseUrlApi}korba`);
    return response?.data;
  } catch (error) {
    throw error;
  }
});

export const getDonationData = async (key: string, id?: string) => {
  try {
    const response = await axios.get(
      `https://api.moyasar.com/v1/payments/${id}`,
      {
        auth: {
          username: key,
          password: "",
        },
      }
    );
    return response?.data;
  } catch (error) {
    throw error;
  }
};

export const toAddDonation = async (data: any) => {
  try {
    const response = await axios.post(
      `${baseUrlApi}donation/checkout/savepayment`,
      data,
      {
        headers: {
          "Accept-Language": "en",
        },
      }
    );
    return response?.data;
  } catch (error) {
    throw error;
  }
};

export const toAddRating = async (data: any) => {
  try {
    const response = await axios.post(`${baseUrlApi}rating`, data);
    return response?.data;
  } catch (error) {
    throw error;
  }
};
// to get  rating
export const getRatingDetails = createAsyncThunk(
  "donation/getRating",
  async (access_token: string | undefined) => {
    try {
      const response = await axios.get(
        `${baseUrlApi}donation/rating/${access_token}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);